import EducationPage from "./EducationPage";

export default [
    {
        path: "/education",
        name: "education",
        component: EducationPage
    }
];